import { render, staticRenderFns } from "./InfoView.vue?vue&type=template&id=70995ee7&scoped=true&"
import script from "./InfoView.vue?vue&type=script&lang=js&"
export * from "./InfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70995ee7",
  null
  
)

export default component.exports